<!-- ////////// -->
<!-- END STYLESHEETS -->

<!-- BEGIN HEADER-->
<header id="header">
  <div class="headerbar">
    <!-- Brand and toggle get grouped for better mobile display -->
    <div class="headerbar-left">
      <ul class="header-nav header-nav-options">
        <li *ngIf="loginMode == 'WEB_ADMIN' && isFranchise == 0">
          <div class="progress" (click)="getClassConfigStatusList()" data-toggle="modal"
            data-target="#class-config-popup"
            style="margin-left: 60px;width: 300px;border-radius: 40px;cursor: pointer;margin-top: 5px;display: grid;">
            <span id="percent-text"
              style="position: absolute;margin-left: 25%; color: #2b323a;width: 100%;grid-column: 1;grid-row: 1;"></span>
            <div style="grid-column: 1;grid-row: 1;" id="percent-progress"
              class="progress-bar progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="40"
              aria-valuemin="0" aria-valuemax="100">
            </div>
          </div>
        </li>
      </ul>
    </div>

    <!-- <app-popup (ok_button_event)="alreadyPaid()" [button_text]="'Already Paid Invoice'" [body_content]="subscriptionDetails?.message" [visible]="subscriptionDetails?.isPaymentDue ? 'block' : 'none'" [title]="subscriptionDetails?.title"></app-popup> -->
    <!-- Class config popup -->
    <div class="modal fade" id="class-config-popup" tabindex="-1" role="dialog" aria-labelledby="simpleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog" style="width: 95%;">
        <div class="modal-content">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true"
            style="margin: -15px;margin-top: -1em;background: var(--brand-primary-color);color: white;padding: 20px 15px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);opacity: inherit;">&times;</button>
          <div class="row" style="background: #f1f1f1;margin-left: 0px !important;margin-right: 0px !important;">
            <div class="col-md-12">
              <h4 class="lead pull-left"
                style="margin: 10px 10px;color: #888888;letter-spacing: 1px;font-size: 12px;text-transform: uppercase;">
                {{ 'header.classConfigurationDetails' | translate }} </h4>
            </div>
          </div>
          <div class="row">
            <div style="text-align: center">
              <i *ngIf="isProcessing" style="position: initial;" class="fa-li fa fa-spinner fa-spin"></i>
            </div>

            <div *ngIf="!isProcessing" class="table-responsive" style="width: 95%;margin-left: 2.5%;">
              <table class="table table-striped" id="class-config-status-table">
                <thead style="background-color: var(--brand-primary-color);color: white;">
                  <tr>
                    <th>{{ 'header.class' | translate }}</th>
                    <th>{{ 'header.students' | translate }}</th>
                    <th>{{ 'header.timetable' | translate }}</th>
                    <th>{{ 'header.sectionMappedWithClass' | translate }}</th>
                    <th>{{ 'header.classTeacher' | translate }}</th>
                    <th>{{ 'header.subjectsMapping' | translate }}</th>
                    <th>{{ 'header.subjectsToTeacherMapping' | translate }}</th>
                    <th>{{ 'header.feesConfiguration' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let c of classConfigList">
                    <td>{{c.classNumber}} - {{c.classDivision}}</td>
                    <td>
                      <span class="hide">{{c.classStudentMapped}}</span>
                      <i *ngIf="c.classStudentMapped" style="color: #008000;" class="fa fa-check"
                        aria-hidden="true"></i>
                      <i *ngIf="!c.classStudentMapped" style="color:#ff0000" class="fa fa-times" aria-hidden="true"></i>
                    </td>
                    <td>
                      <span class="hide">{{c.timetableConfigured}}</span>
                      <i *ngIf="c.timetableConfigured" style="color: #008000;" class="fa fa-check"
                        aria-hidden="true"></i>
                      <i *ngIf="!c.timetableConfigured" style="color:#ff0000" class="fa fa-times"
                        aria-hidden="true"></i>
                    </td>
                    <td>
                      <span class="hide">{{c.isSectionClassMapped}}</span>
                      <i *ngIf="c.isSectionClassMapped" style="color: #008000;" class="fa fa-check"
                        aria-hidden="true"></i>
                      <i *ngIf="!c.isSectionClassMapped" style="color:#ff0000" class="fa fa-times"
                        aria-hidden="true"></i>
                    </td>
                    <td>
                      <span class="hide">{{c.isClassTeacherAssigned}}</span>
                      <i *ngIf="c.isClassTeacherAssigned" style="color: #008000;" class="fa fa-check"
                        aria-hidden="true"></i>
                      <i *ngIf="!c.isClassTeacherAssigned" style="color:#ff0000" class="fa fa-times"
                        aria-hidden="true"></i>
                    </td>
                    <td>
                      <span class="hide">{{c.classSubjectsMapping}}</span>
                      <i *ngIf="c.classSubjectsMapping" style="color: #008000;" class="fa fa-check"
                        aria-hidden="true"></i>
                      <i *ngIf="!c.classSubjectsMapping" style="color:#ff0000" class="fa fa-times"
                        aria-hidden="true"></i>
                    </td>
                    <td>
                      <span class="hide">{{c.teacherAssignedToSubject}}</span>
                      <i *ngIf="c.teacherAssignedToSubject" style="color: #008000;" class="fa fa-check"
                        aria-hidden="true"></i>
                      <i *ngIf="!c.teacherAssignedToSubject" style="color:#ff0000" class="fa fa-times"
                        aria-hidden="true"></i>
                    </td>
                    <td>
                      <span class="hide">{{c.isFeeConfigured}}</span>
                      <i *ngIf="c.isFeeConfigured" style="color: #008000;" class="fa fa-check" aria-hidden="true"></i>
                      <i *ngIf="!c.isFeeConfigured" style="color:#ff0000" class="fa fa-times" aria-hidden="true"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <br>
            <br>
          </div>
        </div>
      </div>
    </div>
    <!-- Class config popup -->

    <!-- New admission form -->
    <div class="modal fade" id="newadmission" tabindex="-1" role="dialog" aria-labelledby="simpleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog" style="width: 95%;">
        <div class="modal-content">
          <div class="modal-header" style="padding: 0px 25px;">
            <button type="button" id="close-modal" class="close" data-dismiss="modal" aria-hidden="true"
              style="margin: 0;margin-top: -1em;background: var(--brand-primary-color);color: white;padding: 20px 15px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);opacity: inherit;">&times;</button>
            <div class="row">
              <!-- <div class="col-lg-12">
                                    <h2 class="text-primary" style="margin: 0;"><img src="images_ext/logo1.png" class="img-respoonsive" style="width: 50px;"> New Admission</h2>
                                    <p style="margin-top: -20px;margin-left: 55px;color: #909090;margin-bottom: 0;">Create new admissions here. </p>
                                </div> -->

              <div class="col-md-12" style="text-align:center;margin-top: -1em;">
                <!-- <div style="float: left;margin-top: -10px;border-right: 1px solid #ececec;padding-right: 5px;">
                                    <img src="images_ext/logo1.png" class="img-respoonsive" style="width: 50px;">
                                    <span class="text-lg text-bold text-primary">{{ brand.name | uppercase }}</span>
                                    </div> -->
                <!-- <h3 class="text-primary" style="text-transform: uppercase;color:rgb(88, 88, 88);font-weight: 900;margin: 0;"><span style="font-size: 1.5em;margin-right: 10px;color: #656565;border: 1px solid #656565;border-radius: 50%;padding: 10px 13px;"><i class="fa fa-flag"></i></span>{{getSchoolName}}</h3>-->
                <h3 class="text-primary"
                  style="text-transform: uppercase;color:rgb(88, 88, 88);font-weight: 900;margin: 0;"><span
                    style="font-size: 1.5em;margin-right: 10px;color: #656565;border: 1px solid #656565;border-radius: 50%;padding: 10px 13px;"><i
                      class="fa fa-flag"></i></span> {{getSchoolName}}</h3>
                <p style="margin: 0;color: #989898;margin-top: -5px;margin-bottom: 10px;">{{ 'header.createNewAdmissionsHere' | translate }}
                </p>
              </div>

            </div>
          </div>
          <div class="modal-body" style="background: #fbfbfb;padding: 1px;">


            <form class="form">

              <!-- Basic info //////////////// -->
              <div class="row" style="border: 1px solid #e2e2e2;background: white;margin: 15px 0px;margin-top: 25px;">

                <div class="col-md-12">
                  <p class="pull-left text-lg"
                    style="position: relative;margin-top: -1em;background: #888888;color: white;padding: 5px 10px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);">
                    1</p>
                </div>

                <div class="col-md-12">
                  <h4 style="background: #f7f7f7;padding: 10px 10px;margin-top: 0;">{{ 'header.studentBasicInfo' | translate }}</h4>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <input (change)="changeStudName(mStudentName)" [(ngModel)]="mStudentName"
                      [ngModelOptions]="{standalone: true}" type="text" class="form-control" id="admission-student-name"
                      maxlength="100">
                    <label for="admission-student-name">{{ 'header.studentName' | translate }}<span style="color: #F44336;">*</span></label>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <input (change)="changeSurName(mSurName)" [(ngModel)]="mSurName"
                      [ngModelOptions]="{standalone: true}" type="text" class="form-control" id="admission-surname"
                      maxlength="50">
                    <label for="admission-surname">{{ 'header.surname' | translate }}</label>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <select [(ngModel)]="mGenderGroup" [ngModelOptions]="{standalone: true}" id="admission-gender-group"
                      name="select1" class="form-control"
                      style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                      <option id="admission-gender-male" value="1">{{ 'header.male' | translate }}</option>
                      <option id="admission-gender-female" value="0">{{ 'header.female' | translate }}</option>
                    </select>
                    <label for="admission-gender-group">{{ 'header.gender' | translate }}<span style="color: #F44336;">*</span></label>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <input [(ngModel)]="mDOB" [ngModelOptions]="{standalone: true}" type="text" class="form-control"
                      id="admission-dob" style="text-transform: initial;" data-provide="datepicker"
                      data-date-format="dd/mm/yyyy" data-date-end-date="0d">
                    <label for="admission-dob">{{ 'header.dateOfBirth' | translate }}<span style="color: #F44336;">* </span> ({{ 'header.ddmmyyyy' | translate }}
                      )</label>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="form-group">
                    <select [(ngModel)]="mBloodGroup" [ngModelOptions]="{standalone: true}" id="admission-blood-group"
                      name="select1" class="form-control"
                      style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                      <option value="A+">{{ 'header.a+' | translate }}</option>
                      <option value="A-">{{ 'header.a-' | translate }}</option>
                      <option value="B+">{{ 'header.b+' | translate }}</option>
                      <option value="B-">{{ 'header.b-' | translate }}</option>
                      <option value="AB+">{{ 'header.ab+' | translate }}</option>
                      <option value="AB-">{{ 'header.ab-' | translate }}</option>
                      <option value="O+">{{ 'header.o+' | translate }}</option>
                      <option value="O-">{{ 'header.o-' | translate }}</option>
                    </select>
                    <label for="admission-blood-group">{{ 'header.bloodGroup' | translate }}<span style="color: #F44336;">*</span></label>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <select [(ngModel)]="mReligion" [ngModelOptions]="{standalone: true}" id="admission-religion"
                      name="select1" class="form-control"
                      style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                      <option value="Hindu">{{ 'header.hindu' | translate }}</option>
                      <option value="Christian">{{ 'header.christian' | translate }}</option>
                      <option value="Muslim">{{ 'header.muslim' | translate }}</option>
                      <option value="Other">{{ 'header.other' | translate }}</option>

                    </select>
                    <label for="admission-religion">{{ 'header.religion' | translate }}</label>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="form-group">
                    <input (change)="changeCaste(mCast)" [(ngModel)]="mCast" [ngModelOptions]="{standalone: true}"
                      type="text" class="form-control" id="admission-cast">
                    <label for="admission-cast">{{ 'header.caste' | translate }}</label>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <select [(ngModel)]="mNationality" [ngModelOptions]="{standalone: true}" id="admission-nationality"
                      name="select1" class="form-control"
                      style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                      <option value="Afghan">{{ 'header.afghan' | translate }}</option>
                      <option value="Albanian">{{ 'header.albanian' | translate }}</option>
                      <option value="Algerian">{{ 'header.algerian' | translate }}</option>
                      <option value="Andorran">{{ 'header.andorran' | translate }}</option>
                      <option value="Angolan">{{ 'header.angolan' | translate }}</option>
                      <option value="Argentinian">{{ 'header.argentinian' | translate }}</option>
                      <option value="Armenian">{{ 'header.armenian' | translate }}</option>
                      <option value="Australian">{{ 'header.australian' | translate }}</option>
                      <option value="Austrian">{{ 'header.austrian' | translate }}</option>
                      <option value="Azerbaijani">{{ 'header.azerbaijani' | translate }}</option>
                      <option value="Bahamian">{{ 'header.bahamian' | translate }}</option>
                      <option value="Bangladeshi">{{ 'header.bangladeshi' | translate }}</option>
                      <option value="Barbadian">{{ 'header.barbadian' | translate }}</option>
                      <option value="Belorussian">{{ 'header.belorussian' | translate }}</option>
                      <option value="Belgian">{{ 'header.belgian' | translate }}</option>
                      <option value="Beninese">{{ 'header.beninese' | translate }}</option>
                      <option value="Bhutanese">{{ 'header.bhutanese' | translate }}</option>
                      <option value="Bolivian">{{ 'header.bolivian' | translate }}</option>
                      <option value="Bosnian">{{ 'header.bosnian' | translate }}</option>
                      <option value="Brazilian">{{ 'header.brazilian' | translate }}</option>
                      <option value="Briton">{{ 'header.briton' | translate }}</option>
                      <option value="Bruneian">{{ 'header.bruneian' | translate }}</option>
                      <option value="Bulgarian">{{ 'header.bulgarian' | translate }}</option>
                      <option value="Burmese">{{ 'header.burmese' | translate }}</option>
                      <option value="Burundian">{{ 'header.burundian' | translate }}</option>
                      <option value="Cambodian">{{ 'header.cambodian' | translate }}</option>
                      <option value="Cameroonian">{{ 'header.cameroonian' | translate }}</option>
                      <option value="Canadian">{{ 'header.canadian' | translate }}</option>
                      <option value="Chadian">{{ 'header.chadian' | translate }}</option>
                      <option value="Chilean">{{ 'header.chilean' | translate }}</option>
                      <option value="Chinese">{{ 'header.chinese' | translate }}</option>
                      <option value="Colombian">{{ 'header.colombian' | translate }}</option>
                      <option value="Congolese">{{ 'header.congolese' | translate }}</option>
                      <option value="Croatian">{{ 'header.croatian' | translate }}</option>
                      <option value="Cuban">{{ 'header.cuban' | translate }}</option>
                      <option value="Cypriot">{{ 'header.cypriot' | translate }}</option>
                      <option value="Czech">{{ 'header.czech' | translate }}</option>
                      <option value="Dane">{{ 'header.dane' | translate }}</option>
                      <option value="Dominican">{{ 'header.dominican' | translate }}</option>
                      <option value="Ecuadorean">{{ 'header.ecuadorean' | translate }}</option>
                      <option value="Egyptian">{{ 'header.egyptian' | translate }}</option>
                      <option value="Salvadorean">{{ 'header.salvadorean' | translate }}</option>
                      <option value="Englishman">{{ 'header.englishman' | translate }}</option>
                      <option value="Eritrean">{{ 'header.eritrean' | translate }}</option>
                      <option value="Estonian">{{ 'header.estonian' | translate }}</option>
                      <option value="Ethiopian">{{ 'header.ethiopian' | translate }}</option>
                      <option value="Fijian">{{ 'header.fijian' | translate }}</option>
                      <option value="Finn">{{ 'header.finn' | translate }}</option>
                      <option value="Frenchman">{{ 'header.frenchman' | translate }}</option>
                      <option value="Gabonese">{{ 'header.gabonese' | translate }}</option>
                      <option value="Gambian">{{ 'header.gambian' | translate }}</option>
                      <option value="Georgian">{{ 'header.georgian' | translate }}</option>
                      <option value="German">{{ 'header.german' | translate }}</option>
                      <option value="Ghanaian">{{ 'header.ghanaian' | translate }}</option>
                      <option value="Greek">{{ 'header.greek' | translate }}</option>
                      <option value="Grenadian">{{ 'header.grenadian' | translate }}</option>
                      <option value="Guatemalan">{{ 'header.guatemalan' | translate }}</option>
                      <option value="Guinean">{{ 'header.guinean' | translate }}</option>
                      <option value="Guyanese">{{ 'header.guyanese' | translate }}</option>
                      <option value="Haitian">{{ 'header.haitian' | translate }}</option>
                      <option value="Dutchman">{{ 'header.dutchman' | translate }}</option>
                      <option value="Honduran">{{ 'header.honduran' | translate }}</option>
                      <option value="Hungarian">{{ 'header.hungarian' | translate }}</option>
                      <option value="Icelander">{{ 'header.icelander' | translate }}</option>
                      <option value="Indian">{{ 'header.indian' | translate }}</option>
                      <option value="Indonesian">{{ 'header.indonesian' | translate }}</option>
                      <option value="Iranian">{{ 'header.iranian' | translate }}</option>
                      <option value="Iraqi">{{ 'header.iraqi' | translate }}</option>
                      <option value="Irishman">{{ 'header.irishman' | translate }}</option>
                      <option value="Israeli">{{ 'header.israeli' | translate }}</option>
                      <option value="Italian">{{ 'header.italian' | translate }}</option>
                      <option value="Jamaican">{{ 'header.jamaican' | translate }}</option>
                      <option value="Japanese">{{ 'header.japanese' | translate }}</option>
                      <option value="Jordanian">{{ 'header.jordanian' | translate }}</option>
                      <option value="Kazakh">{{ 'header.kazakh' | translate }}</option>
                      <option value="Kenyan">{{ 'header.kenyan' | translate }}</option>
                      <option value="Korean">{{ 'header.korean' | translate }}</option>
                      <option value="Kuwaiti">{{ 'header.kuwaiti' | translate }}</option>
                      <option value="Laotian">{{ 'header.laotian' | translate }}</option>
                      <option value="Latvian">{{ 'header.latvian' | translate }}</option>
                      <option value="Lebanese">{{ 'header.lebanese' | translate }}</option>
                      <option value="Liberian">{{ 'header.liberian' | translate }}</option>
                      <option value="Libyan">{{ 'header.libyan' | translate }}</option>
                      <option value="Liechtensteiner">{{ 'header.liechtensteiner' | translate }}</option>
                      <option value="Lithuanian">{{ 'header.lithuanian' | translate }}</option>
                      <option value="Luxembourger">{{ 'header.luxembourger' | translate }}</option>
                      <option value="Macedonian">{{ 'header.macedonian' | translate }}</option>
                      <option value="Madagascan">{{ 'header.madagascan' | translate }}</option>
                      <option value="Malawian">{{ 'header.malawian' | translate }}</option>
                      <option value="Malaysian">{{ 'header.malaysian' | translate }}</option>
                      <option value="Maldivian">{{ 'header.maldivian' | translate }}</option>
                      <option value="Malian">{{ 'header.malian' | translate }}</option>
                      <option value="Maltese">{{ 'header.maltese' | translate }}</option>
                      <option value="Mauritanian">{{ 'header.mauritanian' | translate }}</option>
                      <option value="Mauritian">{{ 'header.mauritian' | translate }}</option>
                      <option value="Mexican">{{ 'header.mexican' | translate }}</option>
                      <option value="Moldovan">{{ 'header.moldovan' | translate }}</option>
                      <option value="Monacan">{{ 'header.monacan' | translate }}</option>
                      <option value="Mongolian">{{ 'header.mongolian' | translate }}</option>
                      <option value="Montenegrin">{{ 'header.montenegrin' | translate }}</option>
                      <option value="Moroccan">{{ 'header.moroccan' | translate }}</option>
                      <option value="Mozambican">{{ 'header.mozambican' | translate }}</option>
                      <option value="Namibian">{{ 'header.namibian' | translate }}</option>
                      <option value="Nepalese">{{ 'header.nepalese' | translate }}</option>
                      <option value="Nicaraguan">{{ 'header.nicaraguan' | translate }}</option>
                      <option value="Nigerien">{{ 'header.nigerien' | translate }}</option>
                      <option value="Nigerian">{{ 'header.nigerian' | translate }}</option>
                      <option value="Norwegian">{{ 'header.norwegian' | translate }}</option>
                      <option value="Pakistani">{{ 'header.pakistani' | translate }}</option>
                      <option value="Panamanian">{{ 'header.panamanian' | translate }}</option>
                      <option value="Paraguayan">{{ 'header.paraguayan' | translate }}</option>
                      <option value="Peruvian">{{ 'header.peruvian' | translate }}</option>
                      <option value="Filipino">{{ 'header.filipino' | translate }}</option>
                      <option value="Pole">{{ 'header.pole' | translate }}</option>
                      <option value="Portuguese">{{ 'header.portuguese' | translate }}</option>
                      <option value="Qatari">{{ 'header.qatari' | translate }}</option>
                      <option value="Romanian">{{ 'header.romanian' | translate }}</option>
                      <option value="Russian">{{ 'header.russian' | translate }}</option>
                      <option value="Rwandan">{{ 'header.rwandan' | translate }}</option>
                      <option value="Saudi">{{ 'header.saudi' | translate }}</option>
                      <option value="Scot">{{ 'header.scot' | translate }}</option>
                      <option value="Senegalese">{{ 'header.senegalese' | translate }}</option>
                      <option value="Serbian">{{ 'header.serbian' | translate }}</option>
                      <option value="Singaporean">{{ 'header.singaporean' | translate }}</option>
                      <option value="Slovak">{{ 'header.slovak' | translate }}</option>
                      <option value="Slovenian">{{ 'header.slovenian' | translate }}</option>
                      <option value="Somali">{{ 'header.somali' | translate }}</option>
                      <option value="Spaniard">{{ 'header.spaniard' | translate }}</option>
                      <option value="Sri-lankan">{{ 'header.sriLankan' | translate }}</option>
                      <option value="Sudanese">{{ 'header.sudanese' | translate }}</option>
                      <option value="Surinamese">{{ 'header.surinamese' | translate }}</option>
                      <option value="Swazi">{{ 'header.swazi' | translate }}</option>
                      <option value="Swede">{{ 'header.swede' | translate }}</option>
                      <option value="Swiss">{{ 'header.swiss' | translate }}</option>
                      <option value="Syrian">{{ 'header.syrian' | translate }}</option>
                      <option value="Taiwanese">{{ 'header.taiwanese' | translate }}</option>
                      <option value="Tadzhik">{{ 'header.tadzhik' | translate }}</option>
                      <option value="Tanzanian">{{ 'header.tanzanian' | translate }}</option>
                      <option value="Thai">{{ 'header.thai' | translate }}</option>
                      <option value="Togolese">{{ 'header.togolese' | translate }}</option>
                      <option value="Trinidadian">{{ 'header.trinidadian' | translate }}</option>
                      <option value="Tunisian">{{ 'header.tunisian' | translate }}</option>
                      <option value="Turk">{{ 'header.turk' | translate }}</option>
                      <option value="Ugandan">{{ 'header.ugandan' | translate }}</option>
                      <option value="Ukrainian">{{ 'header.ukrainian' | translate }}</option>
                      <option value="Kingdom">{{ 'header.kingdom' | translate }}</option>
                      <option value="United">{{ 'header.united' | translate }}</option>
                      <option value="American">{{ 'header.american' | translate }}</option>
                      <option value="Uruguayan">{{ 'header.uruguayan' | translate }}</option>
                      <option value="Uzbek">{{ 'header.uzbek' | translate }}</option>
                      <option value="Venezuelan">{{ 'header.venezuelan' | translate }}</option>
                      <option value="Vietnamese">{{ 'header.vietnamese' | translate }}</option>
                      <option value="Welshman">{{ 'header.welshman' | translate }}</option>
                      <option value="Yemeni">{{ 'header.yemeni' | translate }}</option>
                      <option value="Yugoslav">{{ 'header.yugoslav' | translate }}</option>
                      <option value="Zambian">{{ 'header.zambian' | translate }}</option>
                      <option value="Zimbabwean">{{ 'header.zimbabwean' | translate }}</option>
                    </select>
                    <label for="admission-nationality">{{ 'header.nationality' | translate }}<span style="color: #F44336;">*</span></label>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="form-group">
                    <input (change)="changeEmail(mStudentEmail)" type="email" [(ngModel)]="mStudentEmail"
                      [ngModelOptions]="{standalone: true}" class="form-control" id="admission-student-email">
                    <label for="admission-student-email">{{ 'header.studentEmail' | translate }}</label>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group ">
                    <input type="text" placeholder="{{ 'header.mobileNumberForStaff' | translate }}" id="mobile-number" class="form-control"
                      [ngModelOptions]="{standalone: true}" [ngClass]="{
                        'input-field-registration-page': !invalidMobileNumber,
                        'input-field-registration-page-error': invalidMobileNumber
                      }" [disabled]="loader" #addStudentMobileNumber
                      (input)="handleDebounceMobileNumber(addStudentMobileNumber)" pattern="[0-9]*"
                      (keydown)="handleKeyDown($event)" autocomplete="off" [(ngModel)]="addStudentMobileNumberParsed" />
                    <label for="admission-phone-number">{{ 'header.contactNumber' | translate }}</label>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <input [(ngModel)]="addNewStudentPENNumber" [ngModelOptions]="{standalone: true}"
                      class="form-control changePENNo" id="admission-pen-number" maxlength="12" type="text"
                      (keydown)="handleKeyDown($event)">
                    <label for="admission-pen-number">{{ 'header.permanentEducationalNumberpen' | translate }} </label>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <input (keyup)="changeAadharNumber(mStudenAadharNumber)" [(ngModel)]="mStudenAadharNumber"
                      [ngModelOptions]="{standalone: true}" type="text" class="form-control"
                      id="admission-aadhar-number" maxlength="12">
                    <label for="admission-phone-number">{{ 'header.aadharuidNumber' | translate }}</label>
                  </div>
                </div>

                <div class="col-md-3" *ngIf="houseNameList.length > 0">
                  <div class="form-group">
                    <select id="admission-student-housename" name="admission-student-housename" class="form-control"
                      style="text-transform: uppercase;border: 1px solid #e2e2e2;">
                      <option [value]="null">{{ 'header.none' | translate }}</option>
                      <option *ngFor="let house of houseNameList" [value]="house.houseName">{{house.houseName}}</option>
                    </select>
                    <label for="admission-student-housename" style="margin-top: -8px;">{{ 'header.houseName' | translate }}</label>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group" style="display: flex;">
                    <div class="col-md-12 hide" style="text-align:center;"
                      id="new-addmission-student-aadhar-progressbar-div">
                      <h5 class="progress" id="new-addmission-student-aadhar-progressbar"
                        style="text-align: center;cursor: pointer;display: inline-block;border: 1px solid #e2e2e2;padding: 9px 0px;margin: 1em -2em;color: var(--secondary-btn-bg-color);font-size: 9px;text-transform: uppercase;width: 150px;">
                        {{ 'header.uploading' | translate }}</h5>
                    </div>

                    <img src="" id="new-addmission-student-aadhar-image-ele" class="add-student-aadhar-image"
                      style="width: 63px;height: 40px;margin-top: 6px;">
                    <i class="fas fa-file-pdf hide" id="addmission-aadhar-pdf-icon" style="margin-left: 10px; width: 63px; height: 40px; margin-top: 3px;  color: red;
font-size: 39px;"></i>
                    <button id="new-addmission-student-aadhar-copy-button" style="margin-top: -1px;margin-left: -4px"
                      (click)="openNewAdmissionStudentAadharCopyUpload()"
                      class="btn-raised ink-reaction form-control">{{ 'header.upload' | translate }}</button>
                    <input (change)="startUploadingNewAdmissionStudentAadharCopy()" style="width: 1px;height: 1px"
                      type="file" class="form-control hide" id="new-addmission-student-aadhar-copy">
                    <label for="admission-phone-number" style="margin-top: -6px;">{{ 'header.aadharCopy' | translate }}</label>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="form-group" style="display: flex;">
                    <div class="col-md-12 hide" style="text-align:center;"
                      id="new-addmission-student-tc-or-birth-certificate-progressbar-div">
                      <h5 class="progress" id="new-addmission-student-tc-or-birth-certificate-progressbar"
                        style="text-align: center;cursor: pointer;display: inline-block;border: 1px solid #e2e2e2;padding: 9px 0px;margin: 1em -2em;color: var(--secondary-btn-bg-color);font-size: 9px;text-transform: uppercase;width: 150px;">
                        {{ 'header.uploading' | translate }}</h5>
                    </div>
                    <img src="" id="new-addmission-student-tc-or-birth-image-ele" class="add-student-aadhar-image"
                      style="width: 63px;height: 40px;margin-top: 6px;">
                    <i class="fas fa-file-pdf hide" id="addmission-tc-or-birth-pdf-icon" style="margin-left: 10px; width: 63px; height: 40px; margin-top: 3px;  color: red;
font-size: 39px;"></i>
                    <button id="new-addmission-student-tc-or-birth-copy-button" style="margin-top: 5px;margin-left: 1px"
                      (click)="openNewStudentTcOrBirthCopyUpload()"
                      class="btn-raised ink-reaction form-control">{{ 'header.upload' | translate }}</button>
                    <input (change)="startUploadingNewTcOrBirthCopy()" style="width: 1px;height: 1px" type="file"
                      class="form-control hide" id="new-addmission-student-tc-or-birth-copy">
                    <label for="new-addmission-student-tc-or-birth-copy">{{ 'header.tcBirthCertificate' | translate }} </label>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="form-group">
                    <select [(ngModel)]="mCast" id="admission-cast" name="selectCaste" class="form-control"
                      style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                      <option value="General">{{ 'header.general' | translate }}</option>
                      <option value="OBC">{{ 'header.obc' | translate }}</option>
                      <option value="ST">{{ 'header.st' | translate }}</option>
                      <option value="SC">{{ 'header.sc' | translate }}</option>
                    </select>
                    <label for="admission-cast">{{ 'header.casteCategory' | translate }}</label>
                  </div>
                </div>

                <div class="col-md-2 ">
                  <div class="form-group" style="display: flex;">
                    <img src="" id="new-admission-student-caste-image-ele" class="add-student-aadhar-image"
                      style="width: 63px;height: 40px;margin-top: 6px;">
                    <i class="fas fa-file-pdf hide" id="addmission-caste-pdf-icon" style="margin-left: 10px; width: 63px; height: 40px; margin-top: 3px;  color: red;
font-size: 39px;"></i>
                    <button id="new-admission-student-caste-copy-button" (click)="openNewStudentCasteCopyUpload()"
                      class="btn-raised ink-reaction form-control upload-button">{{ 'header.upload' | translate }}</button>
                    <input (change)="startUploadingNewCasteCopy()" type="file" class="form-control hide image-input"
                      id="new-admission-student-caste-copy">
                    <label for="admission-phone-number">{{ 'header.casteCategoryCopy' | translate }}</label>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="input-check-box-container">
                    <input [(ngModel)]="addNewIsMinority" [ngModelOptions]="{standalone: true}"
                      class="check-box-input-filed" id="new-admission-minority" type="checkbox">
                    <label for="new-admission-minority" class="label-input-check-box">{{ 'header.minority' | translate }} </label>
                  </div>
                </div>
              </div>

              <!-- whether the candidate is  -->
              <div class="row" style="background: white;margin: 15px 0px;margin-top: 25px;">
                <div class="col-md-12">
                  <p class="pull-left text-lg"
                    style="position: relative;background: #888888;color: white;padding: 0px 10px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);margin-right: 10px;">
                    2</p>
                  <h4 style="padding: 10px 10px;margin-top: 0;font-weight: 400;color: #888888;">{{ 'header.whetherTheCandidateIs' | translate }}
                     </h4>
                </div>

                <div class="col-md-12">
                  <div class="col-md-6">
                    <div class="input-check-box-container">
                      <input class="check-box-input-filed" id="admission-specially-abled" type="checkbox"
                        [ngModelOptions]="{standalone: true}" [(ngModel)]="addNewStudentIsSpeciallyDisabled">
                      <label class="label-input-check-box">{{ 'header.speciallyAbledDivyangjan' | translate }} </label>
                    </div>
                  </div>

                  <div class="col-md-3" *ngIf="addNewStudentIsSpeciallyDisabled">
                    <div class="form-group image-container">
                      <img src="" id="new-addmission-student-Divyangjan-image-ele" class="add-student-aadhar-image hide"
                        style="width: 63px;height: 40px;margin-top: 6px;">
                      <i class="fas fa-file-pdf hide" id="addmission-divyangjan-pdf-icon" style="margin-left: 10px; width: 63px; height: 40px; margin-top: 3px;  color: red;
font-size: 39px;"></i>
                      <button id="new-addmission-student-Divyangjan-copy-button"
                        (click)="openNewStudentDivyangjanCopyUpload()"
                        class="btn-raised ink-reaction form-control upload-button">{{ 'header.upload' | translate }}</button>
                      <input (change)="startUploadingNewDivyangjanCopy()" type="file"
                        class="form-control hide image-input" id="new-addmission-student-Divyangjan-copy">
                      <label for="admission-phone-number">{{ 'header.divyangjanCopy' | translate }}</label>
                    </div>
                  </div>
                </div>

                <div class="col-md-12" *ngIf="mGenderGroup === '0'">
                  <div class="col-md-6">
                    <div class="input-check-box-container">
                      <input class="check-box-input-filed" id="admission-single-girl-child" type="checkbox"
                        [ngModelOptions]="{standalone: true}" [(ngModel)]="addNewStudentIsSingleGirlChild">
                      <label for="admission-single-girl-child" class="label-input-check-box">{{ 'header.singleGirlChild' | translate }}
                      </label>
                    </div>
                  </div>

                  <div class="col-md-3" *ngIf="addNewStudentIsSingleGirlChild">
                    <div class="form-group image-container">
                      <img src="" id="new-addmission-student-single-girl-image-ele"
                        class="add-student-aadhar-image hide" style="width: 63px;height: 40px;margin-top: 6px;">
                      <i class="fas fa-file-pdf hide" id="addmission-single-girl-pdf-icon" style="margin-left: 10px; width: 63px; height: 40px; margin-top: 3px;  color: red;
font-size: 39px;"></i>
                      <button id="new-addmission-student-single-girl-copy-button"
                        (click)="openNewStudentSingleGirlCopyUpload()"
                        class="btn-raised ink-reaction form-control upload-button">{{ 'header.upload' | translate }}</button>
                      <input (change)="startUploadingNewSingleGirlCopy()" type="file"
                        class="form-control hide image-input" id="new-addmission-student-single-girl-copy">
                      <label for="admission-phone-number">{{ 'header.singleGirlChildCopy' | translate }}</label>
                    </div>
                  </div>
                </div>

                <div class="col-md-12" *ngIf="mCast === 'General'">
                  <div class="col-md-6">
                    <div class="input-check-box-container">
                      <input class="check-box-input-filed" id="admission-ews" type="checkbox"
                        [ngModelOptions]="{standalone: true}" [(ngModel)]="addNewStudentIsEWS">
                      <label for="admission-ews" class="label-input-check-box">{{ 'header.belongingToEwsEconomically' | translate }}
                        {{ 'header.weaker' | translate }}
                        {{ 'header.section' | translate }}) </label>
                    </div>
                  </div>

                  <div class="col-md-3" *ngIf="addNewStudentIsEWS">
                    <div class="form-group image-container">

                      <img src="" id="new-addmission-student-EWS-image-ele" class="add-student-aadhar-image hide"
                        style="width: 63px;height: 40px;margin-top: 6px;">
                      <i class="fas fa-file-pdf hide" id="addmission-EWS-pdf-icon" style="margin-left: 10px; width: 63px; height: 40px; margin-top: 3px;  color: red;
font-size: 39px;"></i>
                      <button id="new-addmission-student-EWS-copy-button" (click)="openNewStudentEWSCopyUpload()"
                        class="btn-raised ink-reaction form-control upload-button">{{ 'header.upload' | translate }}</button>
                      <input (change)="startUploadingNewEWSCopy()" type="file" class="form-control hide image-input"
                        id="new-addmission-student-EWS-copy">
                      <label for="admission-phone-number">{{ 'header.ewsCopy' | translate }}</label>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Admission details//////////// -->
              <div class="row" style="border: 1px solid #e2e2e2;background: white;margin: 15px 0px;margin-top: 25px;">

                <div class="col-md-12">
                  <p class="pull-left text-lg"
                    style="position: relative;margin-top: -1em;background: #888888;color: white;padding: 5px 10px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);">
                    3</p>
                </div>

                <div class="col-md-12">
                  <h4 style="background: #f7f7f7;padding: 10px 10px;margin-top: 0;">{{ 'header.admissionDetails' | translate }}</h4>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <select (change)="changeAcademic(selectedAcademicYear)" id="select-academic-year"
                      [(ngModel)]="selectedAcademicYear" [ngModelOptions]="{standalone: true}"
                      (ngModelChange)="updateSelectedAcademic($event)" name="select1" class="form-control"
                      style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                      <option value="0">{{ 'header.selectAcademicYear' | translate }}</option>
                      <option *ngFor="let o of academicYearsList" [value]="o.pkAcademicId">{{o.Year}}</option>
                    </select>
                    <label for="select-academic-year">{{ 'header.selectAcademicYear' | translate }}<span style="color: #F44336;">*</span></label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <select [(ngModel)]="admissionBase" [ngModelOptions]="{standalone: true}" id="admission-base"
                      name="select1" class="form-control"
                      style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                      <option value="written">{{ 'header.writtenExam' | translate }}</option>
                      <option value="interview">{{ 'header.interview' | translate }}</option>
                    </select>
                    <label for="admission-base">{{ 'header.admissionBase' | translate }}<span style="color: #F44336;">*</span></label>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <select [(ngModel)]="mAdmissionStream" [ngModelOptions]="{standalone: true}" id="admission-stream"
                      name="select1" class="form-control"
                      style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                      <option value="general">{{ 'header.generalDefault' | translate }}</option>
                      <option *ngFor="let o of studentCategoryListForAdmission" [value]="o.pkStudentsCategoryId">
                        {{o.Name}}</option>
                    </select>
                    <label for="admission-stream">{{ 'header.feesCategory' | translate }}<span style="color: #F44336;">*</span></label>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <select (change)="changeCategory(selectedCategory)" id="admission-select-category"
                      [(ngModel)]="selectedCategory" [ngModelOptions]="{standalone: true}"
                      (ngModelChange)="updateSelectedCategory($event)" name="select1" class="form-control"
                      style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                      <option value="0">{{ 'header.selectCategory' | translate }}</option>
                      <option *ngFor="let o of categoryList" [value]="o.categoryId">{{o.categoryName}}</option>
                    </select>
                    <label for="admission-select-category">{{ 'header.selectClassCategory' | translate }}<span
                        style="color: #F44336;">*</span></label>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <select (change)="changeClass(selectedClassSection)" id="add-classname"
                      [(ngModel)]="selectedClassSection" (ngModelChange)="updateSelectedClassSection($event)"
                      name="select1" class="form-control"
                      style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                      <option value="0">{{ 'header.selectClass' | translate }}</option>
                      <option *ngFor="let o of classSectionList" [value]="o.classid">{{o.classname}}</option>
                    </select>
                    <label for="add-classname">{{ 'header.selectClass' | translate }}<span style="color: #F44336;">*</span></label>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <select (change)="changeClassSection(selectedClassSectionId)" id="add-clname"
                      [(ngModel)]="selectedClassSectionId" (ngModelChange)="updateSelectedClassSectionId($event)"
                      name="select1" class="form-control"
                      style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                      <option value="0">{{ 'header.selectSection' | translate }}</option>
                      <option *ngFor="let o of classSections" [value]="o.claaSectionId">{{o.classSection}}</option>
                    </select>
                    <label for="add-clname">{{ 'header.selectClassSection' | translate }}<span style="color: #F44336;">*</span></label>
                  </div>
                </div>

                <div class="col-md-2" *ngIf="generateStudentRegistrationId == 'MANUAL'">
                  <div class="form-group">
                    <input [(ngModel)]="mAdmissionNumber" [ngModelOptions]="{standalone: true}" type="text"
                      class="form-control" id="regular2">
                    <label for="regular2">{{ 'header.admissionNumber' | translate }}<span style="font-size: 10px;"
                        class="last_registration_number"></span></label>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <input [(ngModel)]="mAdmissionDate" [ngModelOptions]="{standalone: true}" type="text"
                      class="form-control" id="admission-date" style="text-transform: initial;"
                      data-provide="datepicker" data-date-format="dd/mm/yyyy" >
                    <label for="admission-date">{{ 'header.admissionDate' | translate }}<span style="color: #F44336;">* </span> ({{ 'header.ddmmyyyy' | translate }}
                      )</label>
                  </div>
                </div>
              </div>



              <!-- Parent info/////////////////// -->
              <div class="row" style="border: 1px solid #e2e2e2;background: white;margin: 15px 0px;margin-top: 25px;">

                <div class="col-md-12">
                  <p class="pull-left text-lg"
                    style="position: relative;margin-top: -1em;background: #888888;color: white;padding: 5px 10px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);">
                    4</p>
                </div>

                <div class="row" style="margin: 0;">
                  <div class="col-md-12">
                    <h4 style="background: #f7f7f7;padding: 10px 10px;margin-top: 0;">{{ 'header.fathersDetails' | translate }}</h4>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input (change)="changeFatherName(mFatherName)" [(ngModel)]="mFatherName"
                        [ngModelOptions]="{standalone: true}" type="text" class="form-control"
                        id="admission-father-name" maxlength="100">
                      <label for="admission-father-name">{{ 'header.fathersName' | translate }}<span style="color: #F44336;">*</span></label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <input type="text" placeholder="{{ 'header.enterContactNumber' | translate }}" id="add-father-mobile-number"
                        [ngModelOptions]="{standalone: true}" class="form-control changeMobNo" [ngClass]="{
                          'input-field-registration-page': !invalidAddStudentFatherMobileNumber,
                          'input-field-registration-page-error': invalidAddStudentFatherMobileNumber
                        }" #addFatherMobileNumber
                        (input)="addStudentMobileFatherNumberValidator(addFatherMobileNumber)"
                        (keydown)="handleKeyDown($event)" autocomplete="off"
                        [(ngModel)]="addStudentFatherMobileNumberInput" maxlength="20" />
                      <label for="admission-fMob">{{ 'header.contactNumber' | translate }}<span style="color: #F44336;">*</span></label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <select [(ngModel)]="mFatherOccupation" [ngModelOptions]="{standalone: true}"
                        id="admission-father-occupation" name="select1" class="form-control"
                        style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                        <option value="0"></option>
                        <option value="Agriculture, Food and Natural Resources">{{ 'header.agricultureFoodAndNaturalResources' | translate }}
                        </option>
                        <option value="Architecture and Construction">{{ 'header.architectureAndConstruction' | translate }}</option>
                        <option value="Arts, Audio/Video Technology and Communications">{{ 'header.artsAudiovideoTechnologyAnd' | translate }}
                          {{ 'header.communications' | translate }}</option>
                        <option value="Business Management and Administration">{{ 'header.businessManagementAndAdministration' | translate }}
                        </option>
                        <option value="Education and Training">{{ 'header.educationAndTraining' | translate }}</option>
                        <option value="Finance">{{ 'header.finance' | translate }}</option>
                        <option value="Government and Public Administration">{{ 'header.governmentAndPublicAdministration' | translate }}
                        </option>
                        <option value="Health Science">{{ 'header.healthScience' | translate }}</option>
                        <option value="Hospitality and Tourism">{{ 'header.hospitalityAndTourism' | translate }}</option>
                        <option value="Human Services">{{ 'header.humanServices' | translate }}</option>
                        <option value="Information Technology">{{ 'header.informationTechnology' | translate }}</option>
                        <option value="Law, Public Safety, Corrections and Security">{{ 'header.lawPublicSafetyCorrectionsAnd' | translate }}
                          {{ 'header.security' | translate }}</option>
                        <option value="Manufacturing">{{ 'header.manufacturing' | translate }}</option>
                        <option value="Marketing, Sales and Service">{{ 'header.marketingSalesAndService' | translate }}</option>
                        <option value="Science, Technology, Engineering and Mathematics">{{ 'header.scienceTechnology' | translate }}
                          {{ 'header.engineeringAndMathematics' | translate }}</option>
                        <option value="Transportation, Distribution and Logistics">{{ 'header.transportationDistributionAnd' | translate }}
                          {{ 'header.logistics' | translate }}</option>
                        <option value="Others">{{ 'header.others' | translate }}</option>
                      </select>
                      <label for="admission-father-occupation">{{ 'header.occupation' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input (change)="changeFatherQual(mFatherQualification)" [(ngModel)]="mFatherQualification"
                        [ngModelOptions]="{standalone: true}" type="text" class="form-control" id="admission-edu">
                      <label for="admission-edu">{{ 'header.educationalQualification' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input type="text" class="form-control" id="father-annual-income"
                        [(ngModel)]="addNewStudentFatherAnnualIncome" [ngModelOptions]="{standalone: true}"
                        (keydown)="handleKeyDown($event)">
                      <label for="regular2">{{ 'header.annualIncome' | translate }}</label>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <div class="form-group">
                      <input [(ngModel)]="addNewFatherPinCode" [ngModelOptions]="{standalone: true}"
                        class="form-control" id="admission-pincode" maxlength="6" type="text"
                        (keydown)="handleKeyDown($event)">
                      <label for="admission-pincode">{{ 'header.pinCode' | translate }} </label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <input (change)="changeFatherEmail(mFatherEmail)" type="email" [(ngModel)]="mFatherEmail"
                        [ngModelOptions]="{standalone: true}" class="form-control" id="admission-father-email">
                      <label for="admission-father-email">{{ 'header.fatherEmail' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <textarea (change)="changeFatherAdd(mFatherAddress)" [(ngModel)]="mFatherAddress"
                        [ngModelOptions]="{standalone: true}" name="textarea1" id="admission-staddress"
                        class="form-control" rows="3"
                        style="text-transform: initial;border: 1px solid #e8e8e8;padding: 12px 10px;margin-top: 5px;"></textarea>
                      <label for="admission-staddress">{{ 'header.contactAddress' | translate }}<span style="color: #F44336;">*</span></label>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin: 0;">
                  <div class="col-md-12">
                    <h4 style="background: #f7f7f7;padding: 10px 10px;margin-top: 0;">{{ 'header.mothersDetails' | translate }}</h4>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input (change)="changeMotherName(mMotherName)" [(ngModel)]="mMotherName"
                        [ngModelOptions]="{standalone: true}" type="text" class="form-control" id="motherName"
                        maxlength="100">
                      <label for="motherName">{{ 'header.mothersName' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <input type="text" placeholder="{{ 'header.enterContactNumber' | translate }}" id="add-student-mother-mobile-number"
                        [ngModelOptions]="{standalone: true}" class="form-control" [ngClass]="{
                          'input-field-registration-page': !invalidAddStudentMotherMobileNumber,
                          'input-field-registration-page-error': invalidAddStudentMotherMobileNumber
                        }" #addStudentMotherMobileNumber
                        (input)="handleDebounceAddStudentMotherMobileNumber(addStudentMotherMobileNumber)"
                        (keydown)="handleKeyDown($event)" autocomplete="off"
                        [(ngModel)]="addNewStudentMotherNumberInput" maxlength="20" />

                      <label for="motherMob">{{ 'header.contactNumber' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <select id="admission-mother-occupation" name="select1" class="form-control"
                        style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                        <option value="0"></option>
                        <option value="Agriculture, Food and Natural Resources">{{ 'header.agricultureFoodAndNaturalResources' | translate }}
                        </option>
                        <option value="Architecture and Construction">{{ 'header.architectureAndConstruction' | translate }}</option>
                        <option value="Arts, Audio/Video Technology and Communications">{{ 'header.artsAudiovideoTechnologyAnd' | translate }}
                          {{ 'header.communications' | translate }}</option>
                        <option value="Business Management and Administration">{{ 'header.businessManagementAndAdministration' | translate }}
                        </option>
                        <option value="Education and Training">{{ 'header.educationAndTraining' | translate }}</option>
                        <option value="Finance">{{ 'header.finance' | translate }}</option>
                        <option value="Government and Public Administration">{{ 'header.governmentAndPublicAdministration' | translate }}
                        </option>
                        <option value="Health Science">{{ 'header.healthScience' | translate }}</option>
                        <option value="Hospitality and Tourism">{{ 'header.hospitalityAndTourism' | translate }}</option>
                        <option value="Human Services">{{ 'header.humanServices' | translate }}</option>
                        <option value="Information Technology">{{ 'header.informationTechnology' | translate }}</option>
                        <option value="Law, Public Safety, Corrections and Security">{{ 'header.lawPublicSafetyCorrectionsAnd' | translate }}
                          {{ 'header.security' | translate }}</option>
                        <option value="Manufacturing">{{ 'header.manufacturing' | translate }}</option>
                        <option value="Marketing, Sales and Service">{{ 'header.marketingSalesAndService' | translate }}</option>
                        <option value="Science, Technology, Engineering and Mathematics">{{ 'header.scienceTechnology' | translate }}
                          {{ 'header.engineeringAndMathematics' | translate }}</option>
                        <option value="Transportation, Distribution and Logistics">{{ 'header.transportationDistributionAnd' | translate }}
                          {{ 'header.logistics' | translate }}</option>
                        <option value="Others">{{ 'header.others' | translate }}</option>
                      </select>
                      <label for="admission-mother-occupation">{{ 'header.occupation' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input [(ngModel)]="mMotherQualification" [ngModelOptions]="{standalone: true}" type="text"
                        class="form-control" id="motherQual">
                      <label for="motherQual">{{ 'header.educationalQualification' | translate }}</label>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <input type="text" class="form-control" id="mother-annual-income"
                        [ngModelOptions]="{standalone: true}" [(ngModel)]="addNewStudentMotherAnnualIncome"
                        (keydown)="handleKeyDown($event)">
                      <label for="regular2">{{ 'header.annualIncome' | translate }}</label>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <div class="form-group">
                      <input [(ngModel)]="addNewMotherPinCode" [ngModelOptions]="{standalone: true}"
                        class="form-control" id="mother-pincode" maxlength="6" type="text"
                        (keydown)="handleKeyDown($event)">
                      <label for="mother-pincode">{{ 'header.pinCode' | translate }} </label>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <div class="form-group">
                      <input (change)="changeMotherEmail(mMotherEmail)" type="email" [(ngModel)]="mMotherEmail"
                        [ngModelOptions]="{standalone: true}" class="form-control" id="admission-mother-email">
                      <label for="admission-mother-email">{{ 'header.motherEmail' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <div class="checkbox checkbox-styled">
                        <label>
                          <input [(ngModel)]="mMotherSameFatherAddress" [ngModelOptions]="{standalone: true}"
                            type="checkbox" value="" (change)="mMotherSameFatherAddressClick()">
                          <span>{{ 'header.useFathersAddressPinCodeAndMobileNumber' | translate }}</span>
                        </label>
                      </div>
                    </div>
                    <div class="form-group">
                      <textarea [(ngModel)]="mMotherAddress" [ngModelOptions]="{standalone: true}" name="textarea1"
                        id="mother-staddress" class="form-control" rows="3"
                        style="text-transform: initial;border: 1px solid #e8e8e8;padding: 12px 10px;margin-top: 5px;">{{mMotherAddress}}</textarea>
                      <label for="mother-staddress">{{ 'header.contactAddress' | translate }}</label>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin: 0;">
                  <div class="col-md-12">
                    <h4 style="background: #f7f7f7;padding: 10px 10px;margin-top: 0;">{{ 'header.guardiansDetails' | translate }}</h4>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input (change)="changeGuarName(mGuardianName)" [(ngModel)]="mGuardianName"
                        [ngModelOptions]="{standalone: true}" type="text" class="form-control" id="guardian-name">
                      <label for="guardian-name">{{ 'header.guardiansName' | translate }}<span style="color: #F44336;"></span></label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <input type="text" placeholder="{{ 'header.enterContactNumber' | translate }}"
                        id="add-student-guardian-mobile-number-admission" [ngModelOptions]="{standalone: true}"
                        class="form-control" [ngClass]="{
                          'add-student-contact-field': !invalidAddStudentGuardianMobileNumber,
                          'add-student-contact-field-error': invalidAddStudentGuardianMobileNumber
                        }" #addStudentGuardianMobileNumber
                        (input)="handleDebounceAddStudentGuardianMobileNumber(addStudentGuardianMobileNumber)"
                        (keydown)="handleKeyDown($event)" autocomplete="off"
                        [(ngModel)]="addNewStudentGuardianNumberInput" maxlength="20" />
                      <label for="guardian-number">{{ 'header.contactNumber' | translate }}<span style="color: #F44336;"></span></label>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <select id="admission-guardian-occupation" name="select1" class="form-control"
                        style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                        <option value="0"></option>
                        <option value="Agriculture, Food and Natural Resources">{{ 'header.agricultureFoodAndNaturalResources' | translate }}
                        </option>
                        <option value="Architecture and Construction">{{ 'header.architectureAndConstruction' | translate }}</option>
                        <option value="Arts, Audio/Video Technology and Communications">{{ 'header.artsAudiovideoTechnologyAnd' | translate }}
                          {{ 'header.communications' | translate }}</option>
                        <option value="Business Management and Administration">{{ 'header.businessManagementAndAdministration' | translate }}
                        </option>
                        <option value="Education and Training">{{ 'header.educationAndTraining' | translate }}</option>
                        <option value="Finance">{{ 'header.finance' | translate }}</option>
                        <option value="Government and Public Administration">{{ 'header.governmentAndPublicAdministration' | translate }}
                        </option>
                        <option value="Health Science">{{ 'header.healthScience' | translate }}</option>
                        <option value="Hospitality and Tourism">{{ 'header.hospitalityAndTourism' | translate }}</option>
                        <option value="Human Services">{{ 'header.humanServices' | translate }}</option>
                        <option value="Information Technology">{{ 'header.informationTechnology' | translate }}</option>
                        <option value="Law, Public Safety, Corrections and Security">{{ 'header.lawPublicSafetyCorrectionsAnd' | translate }}
                          {{ 'header.security' | translate }}</option>
                        <option value="Manufacturing">{{ 'header.manufacturing' | translate }}</option>
                        <option value="Marketing, Sales and Service">{{ 'header.marketingSalesAndService' | translate }}</option>
                        <option value="Science, Technology, Engineering and Mathematics">{{ 'header.scienceTechnology' | translate }}
                          {{ 'header.engineeringAndMathematics' | translate }}</option>
                        <option value="Transportation, Distribution and Logistics">{{ 'header.transportationDistributionAnd' | translate }}
                          {{ 'header.logistics' | translate }}</option>
                        <option value="Others">{{ 'header.others' | translate }}</option>
                      </select>
                      <label for="admission-guardian-occupation">{{ 'header.occupation' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input (change)="changeGuardQual(mGuardianQualification)" [(ngModel)]="mGuardianQualification"
                        [ngModelOptions]="{standalone: true}" type="text" class="form-control" id="guar-qual">
                      <label for="guar-qual">{{ 'header.educationalQualification' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input type="text" class="form-control" id="guardian-annual-income"
                        [(ngModel)]="addNewStudentGuardianAnnualIncome" [ngModelOptions]="{standalone: true}"
                        (keydown)="handleKeyDown($event)">
                      <label for="regular2">{{ 'header.annualIncome' | translate }}</label>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <div class="form-group">
                      <input [(ngModel)]="addNewGuardianPinCode" [ngModelOptions]="{standalone: true}"
                        class="form-control" id="guardian-pincode" maxlength="6" type="text"
                        (keydown)="handleKeyDown($event)">
                      <label for="mother-pincode">{{ 'header.pinCode' | translate }} </label>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="checkbox checkbox-styled">
                      <label>
                        <input (change)="mGuardianSameFatherAddressClick()" [(ngModel)]="mGuardianSameFatherAddress"
                          [ngModelOptions]="{standalone: true}" type="checkbox" value="">
                        <span>{{ 'header.useFathersAddressAndPinCode' | translate }}</span>
                      </label>
                    </div>
                    <div class="form-group">
                      <textarea (change)="changeGuarAdd(mGuardianAddress)" [(ngModel)]="mGuardianAddress"
                        [ngModelOptions]="{standalone: true}" name="textarea1" id="guard-staddress" class="form-control"
                        rows="3"
                        style="text-transform: initial;border: 1px solid #e8e8e8;padding: 12px 10px;margin-top: 5px;">{{mGuardianAddress}}</textarea>
                      <label for="guard-staddress">{{ 'header.contactAddress' | translate }}</label>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Transport //////////////////////-->
              <!-- bus info -->
              <div class="row" style="margin: 0;min-height: 300px;" *ngIf="busStopListData.length>0">
                <div class="col-md-12">
                  <h4 style="background: #f7f7f7;padding: 10px 10px;margin-top: 0;">{{ 'header.selectTransportOptions' | translate }}</h4>

                  <div class="col-md-6">
                    <div class="form-group">
                      <select id="bus-stop-selection-add" (change)="addStd_updateSelectedBusRoute($event.target.value)"
                        name="select1" class="form-control"
                        style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                        <option [value]="0">{{ 'header.notAssigned' | translate }}</option>
                        <option *ngFor="let o of busStopListData" [value]="o.PkBusStopId">{{o.BusStopName}}</option>
                      </select>
                      <label for="bus-stop-selection-add">{{ 'header.selectStop' | translate }}</label>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <select id="bus-selection-add" name="select1" class="form-control"
                        style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                        <option [value]="0">{{ 'header.notAssigned' | translate }}</option>
                        <option *ngFor="let o of busListData" [value]="o.pkBusId">
                          {{o.BusName}}-{{o.BusNumber}}-{{o.RouteName}}({{o.startStop}} {{ 'header.to' | translate }}
                          {{o.endStop}})-(Capacity-{{o.Capacity}})-(Filled-{{o.assignedStudents}})</option>
                      </select>
                      <label for="bus-selection-add">{{ 'header.selectBus' | translate }}</label>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="form-group">
                      <input [(ngModel)]="mTotalBusFees" [ngModelOptions]="{standalone: true}" type="text"
                        class="form-control" id="regular1"
                        style="padding: 35px 10px;font-size: 20px;border: 1px dashed #e2e2e2;color: darkslategray;"
                        disabled="disabled">
                      <label for="regular1">{{ 'header.fare' | translate }}({{currType}})</label>
                    </div>

                  </div>
                  <div *ngIf="isTermsVisible" id="select_busterm_layout" class="col-md-12 animated fadeInUp">
                    <h5>{{ 'header.selectTerms' | translate }}</h5>
                    <label class="checkbox-inline checkbox-styled">
                      <input type="checkbox" (change)="onBusTermChangedSelectAll($event)"><span>{{ 'header.selectAllTerms' | translate }} </span>
                    </label>
                    <div>
                      <label *ngFor="let term of avalialableTermsList" class="checkbox-inline checkbox-styled">
                        <input type="checkbox" [checked]="term.isSelectedTerm" value="{{term.pkBusStopTermId}}"
                          (change)="onBusTermChanged($event,term.pkBusStopTermId)"><span>{{term.termName}} ({{ 'header.dueDate' | translate }}:
                          {{term.termDueDate | date}})</span>
                      </label>
                    </div>

                  </div>
                </div>
              </div>

              <!-- Finish /////////////////////-->
              <div class="row" style="border: 1px solid #e2e2e2;background: white;margin: 15px 0px;margin-top: 25px;">

                <div class="col-md-12">
                  <p class="pull-left text-lg"
                    style="position: relative;margin-top: -1em;background: #888888;color: white;padding: 5px 10px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);">
                    5</p>
                </div>

                <div class="col-md-12 scrollbar-style">
                  <div class="col-md-8" style="text-align: center;padding: 80px 0px;border: 1px dashed #e8e8e8;">
                    <p class="lead" style="font-size: 25px;color: #868585;margin: 0;">{{ 'header.hereYouGoWithNewAdmission' | translate }}
                    </p>
                    <h4 style="color: #6b6b6b;font-weight: 300;">{{ 'header.clickFinishToCompleteTheAdmission' | translate }}</h4>
                  </div>


                  <div class="col-md-4">
                    <div class="cropme-admission student-image"
                      style="width: 150px;min-height: 150px;float: initial;margin: 0 auto;border: 1px dashed  #e0e0e0;">
                      <img src="assets/img/avatar-students.png" id="studentimageadmission" class="img-responsive">
                    </div>
                    <div class="col-md-12" style="text-align:center;">
                      <div class="col-md-12" style="text-align:center;">
                        <h5 class="progress hide" id="studentadmsson-progressbar"
                          style="text-align: center;cursor: pointer;display: inline-block;border: 1px solid #e2e2e2;padding: 9px 0px;margin: 1em -2em;color: var(--secondary-btn-bg-color);font-size: 9px;text-transform: uppercase;width: 150px;">
                          {{ 'header.uploading' | translate }}</h5>
                      </div>
                      <input type="file" class="input-style" id="openfileadmission" style="width:1px; height: 1px">
                      <h5 (click)="openBrowserToUplaodPhotoAddmission()" class="image-edit hide" id="hide-txt-foradmsn"
                        style="text-align: center;cursor: pointer;display: inline-block;border: 1px solid #e2e2e2;padding: 5px 0px;margin: 1em;color: var(--secondary-btn-bg-color);font-size: 9px;text-transform: uppercase;width: 150px;">
                        {{ 'header.uploadStudentImage' | translate }}</h5>
                    </div>
                    <div class="col-md-12" style="text-align:center;display: none;">
                      <p class="lead"
                        style="color: #9a9a9a;font-size: 13px;display: none;border: 1px solid #f1f1f1;padding: 2px 12px;">
                        {{ 'header.uploadStudentImage' | translate }}
                      </p>
                    </div>
                    <div class="col-md-12" style="text-align: center;">
                      <button id="admissionbtndisable" (click)="finishAdmissionProcess1()" type="button"
                        class="btn btn-raised ink-reaction btn-info" data-toggle="dropdown" aria-expanded="false"
                        style="padding: 5px 75px;margin-top: 14em;margin-bottom: 3em;">
                        {{ 'header.finish' | translate }}
                      </button>
                      <div id="new-student-admission-progress-div" class="progress hide"
                        style="width: 300px;border-radius: 40px;">
                        <span id="new-student-admission-percent-text"
                          style="position: absolute;margin-left: -50%;color: #2b323a;width: 100%"></span>
                        <div id="new-student-admission-percent-progress"
                          class="progress-bar progress-bar-success progress-bar-striped active" role="progressbar"
                          aria-valuenow="40" aria-valuemin="0" aria-valuemax="100">
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer" style="text-align: center;background: #e2e2e2;">
            <!-- <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-raised ink-reaction btn-info">Add student</button> -->
            <p style="color: #717171;">© {{currentYear}} {{ 'header.bluewingsAllRightReserved' | translate:{ brandName: brand.name } }}</p>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->
    <!-- ////////////////// -->

    <div id="id-print-floating-button" class="col-md-12" style="text-align: -webkit-right;margin-left: -2%;">
      <!-- <button (click)="print_bulk_id_cards()" class="btn ink-reaction btn-floating-action btn-primary"
        aria-hidden="true"
        style="background: var(--brand-primary-color);border: none;width: 60px;height: 60px;position:fixed;bottom:0;margin: 10em -2em;"
        type="button"><i class="fa fa-print" aria-hidden="true"></i></button> -->

        <!-- <button (click)="print_bulk_id_cards()" class="btn ink-reaction btn-floating-action btn-primary"
        aria-hidden="true"
        style="background: var(--brand-primary-color);border: none;width: 60px;height: 60px;position:fixed;bottom:0;margin: 10em -2em;"
        type="button"><i class="fa fa-print" aria-hidden="true"></i></button> -->

          <button (click)="clear_selected_students()" class="btn ink-reaction btn-floating-action btn-primary"
        aria-hidden="true"
        style="background: var(--brand-primary-color);border: none;width: 60px;height: 60px;position:fixed;bottom:0;margin: 14em -2em;"
        type="button">X</button>

      <button *ngIf="idCardServiceEnables==='true' && isAcademicRunning" (click)="openIdCard()" class="btn ink-reaction btn-floating-action btn-primary"
        aria-hidden="true"
        style="background: var(--brand-primary-color);border: none;width: 60px;height: 60px;position:fixed;bottom:0;margin: 10em -2em;"
        type="button"><i class="ri-id-card-line"></i></button>

        <button *ngIf="transferCertificateEnables==='true' " (click)="openPopUpForTcGeneration()" class="btn ink-reaction btn-floating-action btn-primary"
        aria-hidden="true"
        style="background: var(--brand-primary-color);border: none;width: 60px;height: 60px;position:fixed;bottom:0;margin: 6em -2em;"
        type="button"><i class="ri-article-line"></i></button>
    </div>

    <!-- FOR STAFF -->

        <div id="id-print-floating-button-staff" class="col-md-12" style="text-align: -webkit-right;margin-left: -2%;">

          <button (click)="clear_selected_staffs()" class="btn ink-reaction btn-floating-action btn-primary"
        aria-hidden="true"
        style="background: var(--brand-primary-color);border: none;width: 60px;height: 60px;position:fixed;bottom:0;margin: 14em -2em;"
        type="button">X</button>

      <button *ngIf="staffIdCardServiceEnables==='true'" (click)="openStaffIdCard()" class="btn ink-reaction btn-floating-action btn-primary"
        aria-hidden="true"
        style="background: var(--brand-primary-color);border: none;width: 60px;height: 60px;position:fixed;bottom:0;margin: 10em -2em;"
        type="button"><i class="ri-id-card-line"></i></button>

    </div>



    <div id="multiple-id-cards-trigger" class="hide"></div>
    <div data-toggle="modal" data-target="#student-id-preview-popup" id="student-id-preview-popup-open"></div>
    <div class="modal fade" id="student-id-preview-popup" tabindex="-1" role="dialog" aria-labelledby="simpleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog" style="width: 30%;">
        <div class="modal-content" style="border: 2px solid #324d77;">
          <span class="btn" id="print-id-form"
            style="color: white;float: right;background: #204979;margin-right: 2px;margin-top: 2px;text-transform: unset;">
            {{ 'header.print' | translate }} </span>
          <div class="parent-div-id-card" style="margin-left: 20%;margin-top: 5%">
            <div id="id-receipt-print-container">
              <div *ngFor="let st of idCardDetails?.studentInfo">
                <div style="page-break-after: always">
                </div>
                <!-- Green card -->
                <div *ngIf="!st.busStopName"
                  style="width: 214.094488px;height: 390.480315px;border-radius: 15px 15px;overflow: hidden;perspective: 1px;margin-left: -8px;margin-top: -7px;font-family: Arial">
                  <table style="text-align: -webkit-center;background: #056721;color: white">
                    <tr>
                      <td *ngIf="getSchoolId != '83'">
                        <img style="border-radius: 100px;height: 40px;width: 40px;padding: 5px;"
                          src="{{st.idCardLogo}}">
                      </td>
                      <td *ngIf="getSchoolId == '83'">
                        <img style="border-radius: 20%;height: 40px;width: 40px;padding: 5px;" src="{{st.idCardLogo}}">
                      </td>
                      <td style="width: 100%;text-align: -webkit-center;">
                        <span *ngIf="getSchoolId != '83'"
                          style="letter-spacing: 2px;margin-right: 17px;font-size: 22px;font-weight: bolder;text-transform: uppercase;font-weight: 900;">{{st.schoolNameInIdCard
                          ? st.schoolNameInIdCard : st.schoolName}}</span>
                        <span *ngIf="getSchoolId == '83'"
                          style="letter-spacing: 1px;margin-right: 17px;font-size: 14px;font-weight: bolder;text-transform: uppercase;font-weight: 900;">{{st.schoolNameInIdCard
                          ? st.schoolNameInIdCard : st.schoolName}}</span>
                      </td>
                    </tr>
                  </table>
                  <div
                    style="height: 3%;text-align: center;background-color: yellow;color: green;font-weight: 600;font-size: 10px;">
                    ({{'Affiliated to '+st.affiliatedTo}})
                  </div>
                  <div style="height: 3%;text-align: -webkit-center;background: #056721;color: white;font-size: 10px;">
                    <span style="font-family: Impact, Regular;/*margin-left: -20%;*/">{{ 'header.studentIdCard' | translate }} &nbsp;
                      ({{formatAcademicYear(idCardDetails?.academicInfo.Year)}})</span><!--<span style="float: right;margin-right: 5%;font-weight: 600;">{{idCardDetails?.academicInfo.Year}}</span>-->
                  </div>
                  <div style="height: 48.5%;width:98%">
                    <div style="margin-left: 70px;">
                      <img
                        style="margin-top: 4px;width: 73px;height: 73px;border-style: solid;border-color: #2c661d;border-width: 2px;margin-top: 2px;border-radius: 10px;"
                        bind-src="st.studentImage">
                    </div>
                    <div
                      style="margin-bottom: 3px;margin-top: 1px;color: deeppink;font-weight: 900;text-align: center;font-size: 11px;text-transform: uppercase;">
                      {{st.studentName}}</div>
                    <div *ngIf="st.houseName"
                      style="margin-bottom: 4px;margin-top: -2px;color: deeppink;font-weight: 700;text-align: center;font-size: 9px;text-transform: uppercase;">
                      {{st.houseName}} {{ 'header.house' | translate }}</div>
                    <div
                      style="color: #841cc1;line-height: 12px;font-family: Arial;font-weight: 900;text-align: -webkit-center;">
                      <table border="0"
                        style="font-size: 8px;margin-top: -6px;line-height: normal;margin-left: 5px; text-align: -webkit-center;">
                        <tr style="height:2px;">
                          <td style="font-weight: bold;color: black">{{ 'header.admnno' | translate }}</td>
                          <td>&nbsp;&nbsp;&nbsp;</td>
                          <td>-</td>
                          <td style="color: blue;font-weight: bold">{{st.registrationId}}</td>
                        </tr>
                        <tr style="height:2px;">
                          <td style="font-weight: bold;color: black">{{ 'header.class' | translate }}</td>
                          <td>&nbsp;&nbsp;&nbsp;</td>
                          <td>-</td>
                          <td style="color: blue;font-weight: bold">{{st.className}}</td>
                        </tr>
                        <!-- </tr>
                             <td style="font-weight: bold;color: black">Class</td>
                             <td>&nbsp;</td>
                             <td>-</td>
                             <td>
                               <span style="color: blue;font-weight: bold">{{st.className}}</span>
                               &nbsp;<span style="font-weight: bold;width: 45%;color: black">DOB</span>
                               <span>-</span>
                               <span style="color: blue;font-weight: bold">{{formatDOB(st.dateOfBirth)}}</span>
                             </td>
                           </tr>-->
                        <tr style="height:2px;">
                          <td style="font-weight: bold;color: black">{{ 'header.dob' | translate }}</td>
                          <td>&nbsp;&nbsp;&nbsp;</td>
                          <td>-</td>
                          <td style="color: blue;font-weight: bold">{{formatDOB(st.dateOfBirth)}}</td>
                        </tr>
                        <tr style="height:2px;">
                          <td style="font-weight: bold;color: black">{{ 'header.father' | translate }}</td>
                          <td>&nbsp;&nbsp;&nbsp;</td>
                          <td>-</td>
                          <td style="color: blue;font-weight: bold">{{st.parentName}}</td>
                        </tr>
                        <tr style="height:2px;">
                          <td style="font-weight: bold;color: black">{{ 'header.mobile' | translate }}</td>
                          <td>&nbsp;&nbsp;&nbsp;</td>
                          <td>-</td>
                          <td style="color: blue;font-weight: bold">{{st.mobileNumber}}</td>
                        </tr>
                        <!--<tr style="height:2px;">
                            <td style="font-weight: bold;color: black">Boarding Pt.</td>
                            <td>&nbsp;&nbsp;&nbsp;</td>
                            <td>-</td>
                            <td style="color: blue;font-weight: bold">{{st.busStopName}}</td>
                          </tr>-->
                        <tr style="height:2px;">
                          <td style="font-weight: bold;color: black">{{ 'header.address' | translate }}</td>
                          <td>&nbsp;&nbsp;&nbsp;</td>
                          <td>-</td>
                          <td style="color: blue;font-weight: bold">{{st.address}}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <div
                    style="color: black;margin-left: 173px;font-size: 8px;display: table-caption;margin-bottom: 2px;margin-top: 15px;">
                    <img bind-src="st.principalSign" style=" width: 25px;height: 15px;">
                    <strong style="color: black;font-weight: 600;font-size: 7px;">{{ 'header.principal' | translate }}</strong>
                  </div>
                  <div
                    style="height: 7%;line-height: 1.2;text-align: -webkit-center;background: #056721;color: white;font-size: 10px;border-radius: 0px 0px 15px 15px;overflow: hidden;perspective: 1px;font-weight: 600;">
                    {{st.schoolAaddress}} <br> {{ 'header.ph' | translate }} {{st.phoneNumberInCard}}
                  </div>
                </div>
                <!-- Yellow card -->
                <div *ngIf="st.busStopName"
                  style="width: 214.094488px;height: 390.480315px;border-radius: 15px 15px;overflow: hidden;perspective: 1px;margin-left: -8px;margin-top: -7px;font-family: Arial">
                  <table style="text-align: -webkit-center;background: #fffc00;color: black">
                    <tr>
                      <td *ngIf="getSchoolId != '83'">
                        <img style="border-radius: 100px;height: 40px;width: 40px;padding: 5px;"
                          src="{{st.idCardLogo}}">
                      </td>
                      <td *ngIf="getSchoolId == '83'">
                        <img style="border-radius: 20%;height: 40px;width: 40px;padding: 5px;" src="{{st.idCardLogo}}">
                      </td>
                      <td style="width: 100%;text-align: -webkit-center;">
                        <span *ngIf="getSchoolId != '83'"
                          style="letter-spacing: 2px;margin-right: 17px;font-size: 22px;font-weight: bolder;text-transform: uppercase;font-weight: 900;">{{st.schoolNameInIdCard
                          ? st.schoolNameInIdCard : st.schoolName}}</span>
                        <span *ngIf="getSchoolId == '83'"
                          style="letter-spacing: 1px;margin-right: 17px;font-size: 14px;font-weight: bolder;text-transform: uppercase;font-weight: 900;">{{st.schoolNameInIdCard
                          ? st.schoolNameInIdCard : st.schoolName}}</span>
                      </td>
                    </tr>
                  </table>
                  <div
                    style="height: 3%;text-align: center;background-color: #056721;color: white;font-weight: 600;font-size: 10px;">
                    ({{'Affiliated to '+st.affiliatedTo}})
                  </div>
                  <div style="height: 3%;text-align: -webkit-center;background: #fffc00;color: black;font-size: 10px;">
                    <span style="font-family: Impact, Regular;/*margin-left: -20%;*/">{{ 'header.studentIdCard' | translate }} &nbsp;
                      ({{formatAcademicYear(idCardDetails?.academicInfo.Year)}})</span><!--<span style="float: right;margin-right: 5%;font-weight: 600;">{{idCardDetails?.academicInfo.Year}}</span>-->
                  </div>
                  <div style="height: 48.5%;width:98%">
                    <div style="margin-left: 70px;">
                      <img
                        style="margin-top: 4px;width: 73px;height: 73px;border-style: solid;border-color: #2c661d;border-width: 2px;margin-top: 2px;border-radius: 10px;"
                        bind-src="st.studentImage">
                    </div>
                    <div
                      style="margin-bottom: 3px;margin-top: 1px;color: deeppink;font-weight: 900;text-align: center;font-size: 11px;text-transform: uppercase;">
                      {{st.studentName}}</div>
                    <div *ngIf="st.houseName"
                      style="margin-bottom: 4px;margin-top: -2px;color: deeppink;font-weight: 700;text-align: center;font-size: 9px;text-transform: uppercase;">
                      {{st.houseName}} {{ 'header.house' | translate }}</div>
                    <div
                      style="color: #841cc1;line-height: 12px;font-family: Arial;font-weight: 900;text-align: -webkit-center;">
                      <table border="0"
                        style="font-size: 8px;margin-top: -6px;line-height: normal;margin-left: 5px; text-align: -webkit-center;">
                        <tr style="height:2px;">
                          <td style="font-weight: bold;color: black">{{ 'header.admnno' | translate }}</td>
                          <td>&nbsp;&nbsp;&nbsp;</td>
                          <td>-</td>
                          <td style="color: blue;font-weight: bold">{{st.registrationId}}</td>
                        </tr>
                        <tr style="height:2px;">
                          <td style="font-weight: bold;color: black">{{ 'header.class' | translate }}</td>
                          <td>&nbsp;&nbsp;&nbsp;</td>
                          <td>-</td>
                          <td style="color: blue;font-weight: bold">{{st.className}}</td>
                        </tr>
                        <!-- </tr>
                             <td style="font-weight: bold;color: black">Class</td>
                             <td>&nbsp;</td>
                             <td>-</td>
                             <td>
                               <span style="color: blue;font-weight: bold">{{st.className}}</span>
                               &nbsp;<span style="font-weight: bold;width: 45%;color: black">DOB</span>
                               <span>-</span>
                               <span style="color: blue;font-weight: bold">{{formatDOB(st.dateOfBirth)}}</span>
                             </td>
                           </tr>-->
                        <tr style="height:2px;">
                          <td style="font-weight: bold;color: black">{{ 'header.dob' | translate }}</td>
                          <td>&nbsp;&nbsp;&nbsp;</td>
                          <td>-</td>
                          <td style="color: blue;font-weight: bold">{{formatDOB(st.dateOfBirth)}}</td>
                        </tr>
                        <tr style="height:2px;">
                          <td style="font-weight: bold;color: black">{{ 'header.father' | translate }}</td>
                          <td>&nbsp;&nbsp;&nbsp;</td>
                          <td>-</td>
                          <td style="color: blue;font-weight: bold">{{st.parentName}}</td>
                        </tr>
                        <tr style="height:2px;">
                          <td style="font-weight: bold;color: black">{{ 'header.mobile' | translate }}</td>
                          <td>&nbsp;&nbsp;&nbsp;</td>
                          <td>-</td>
                          <td style="color: blue;font-weight: bold">{{st.mobileNumber}}</td>
                        </tr>
                        <tr style="height:2px;">
                          <td style="font-weight: bold;color: black">{{ 'header.boardingPt' | translate }}</td>
                          <td>&nbsp;&nbsp;&nbsp;</td>
                          <td>-</td>
                          <td style="color: blue;font-weight: bold">{{st.busStopName}}&nbsp;({{st.BusName}})</td>
                        </tr>
                        <tr style="height:2px;">
                          <td style="font-weight: bold;color: black">{{ 'header.address' | translate }}</td>
                          <td>&nbsp;&nbsp;&nbsp;</td>
                          <td>-</td>
                          <td style="color: blue;font-weight: bold">{{st.address}}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <div
                    style="color: black;margin-left: 173px;font-size: 8px;display: table-caption;margin-bottom: 2px;margin-top: 15px;">
                    <img bind-src="st.principalSign" style=" width: 25px;height: 15px;">
                    <strong style="color: black;font-weight: 600;font-size: 7px;">{{ 'header.principal' | translate }}</strong>
                  </div>
                  <div
                    style="height: 7%;line-height: 1.2;text-align: -webkit-center;background: #fffc00;color: black;font-size: 10px;border-radius: 0px 0px 15px 15px;overflow: hidden;perspective: 1px;font-weight: 600;">
                    {{st.schoolAaddress}} <br> {{ 'header.ph' | translate }} {{st.phoneNumberInCard}}
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="edit-student-notificationForFeesForFees-open" data-toggle="modal"
      data-target="#edit-student-notificationForFeesForFees"></div>
    <div id="edit-student-notificationForFeesForFees" class="hide" role="dialog">
      <div class="modal-dialog" style="z-index: 10000;">
        <div class="modal-content" style="height: 20em;">
          <div class="modal-body">
            <h3 style="margin: 0;font-weight: 100;color: #909090;"><i class="fa fa-check-square-o"
                style="color:var(--secondary-btn-bg-color);"></i> {{ 'header.updateStudentDetail' | translate }}</h3>
            <br>
            <div class="col-md-12 text-center" style="border-style: ridge;">
              <div style="text-align: left;">{{ 'header.moving' | translate }} <b>{{editStudentFormData.student.studentName}}</b> {{ 'header.from' | translate }}
                <b>{{updateStudentClassChangeError.oldClassName}}</b> {{ 'header.to' | translate }}
                <b>{{updateStudentClassChangeError.newClassName}}</b> {{ 'header.notAllowed' | translate }}
              </div>
              <div style="text-align: left;"><b>{{ 'header.reason' | translate }} </b>
                <div>&nbsp;&nbsp;&nbsp;1. <b>{{updateStudentClassChangeError.oldClassName}}</b>'{{ 'header.s' | translate }}
                  <b>{{updateStudentClassChangeError.structureName}}</b> {{ 'header.and' | translate }}
                  <b>{{updateStudentClassChangeError.newClassName}}</b>'{{ 'header.s' | translate }}
                  <b>{{updateStudentClassChangeError.structureName}}</b> {{ 'header.feesAreNotMatching' | translate }}
                </div>
                <div>&nbsp;&nbsp;&nbsp;2. <b>{{editStudentFormData.student.studentName}}</b> {{ 'header.alreadyPaid' | translate }}
                  {{currType}}.<b>{{updateStudentClassChangeError.paidAmount}}</b></div>
              </div>
              <div style="text-align: left;">{{ 'header.ifYouStillWantMove' | translate }} <b>{{editStudentFormData.student.studentName}}</b>
                {{ 'header.to' | translate }} <b>{{updateStudentClassChangeError.newClassName}}</b>,&nbsp; {{ 'header.pleaseCanceldeleteHisFeeFromFee' | translate }}
                {{ 'header.collectionAndThenChangeTheClass' | translate }}</div>
            </div>
            <div class="col-md-12 text-center" style="padding:10px 0px;">
              <button class="btn btn-info btn-sm" (click)="closeFeesNotification()">{{ 'header.close' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end of Fees Notification-->
    <!--EDIT STUDENT END-->


    <!-- Collect the nav links, forms, and other content for toggling -->
    <div class="headerbar-right">
      <ul class="header-nav header-nav-options">
        <li *ngIf="loginMode == 'WEB_ADMIN' && permissions.TAKE_ADMISSIONS == 'ENABLED'" class="">
          <!--<a [routerLink]="['/admission']" style="cursor:pointer;border-radius: 30px;padding: 5px 30px;background: #f44336;color: white;">New Admission</a>-->
          <button (click)="callImageUploadTxt()" class="btn btn-default-bright btn-raised" data-toggle="modal"
            data-target="#newadmission"
            style="border-radius: 30px;background: #f44336;color: white;border: none;text-transform: capitalize;font-size: 13px;">{{ 'header.new' | translate }}
            {{ 'header.admission' | translate }}</button>
        </li>
        <li>
          <!-- Search form -->
          <form class="navbar-search hide" role="search">
            <div class="form-group">
              <input type="text" class="form-control" name="headerSearch" [placeholder]="'enterYourKeyword' | translate">
            </div>
            <button type="submit" class="btn btn-icon-toggle ink-reaction"><i class="fa fa-search"></i></button>
          </form>
        </li>
        <li class="dropdown hidden-xs hide">
          <a href="javascript:void(0);" class="btn btn-icon-toggle btn-default" data-toggle="dropdown">
            <i class="fa fa-bell"></i><sup class="badge style-danger">0</sup>
          </a>
          <!--<ul class="dropdown-menu animation-expand">
            <li class="dropdown-header">Today's messages</li>
            <li>
              <a class="alert alert-callout alert-warning" href="javascript:void(0);">
                <img class="pull-right img-circle dropdown-avatar" src="assets/img/avatar2.jpg?1404026449" alt="" />
                <strong>Alex Anistor</strong><br/>
                <small>Testing functionality...</small>
              </a>
            </li>
            <li>
              <a class="alert alert-callout alert-info" href="javascript:void(0);">
                <img class="pull-right img-circle dropdown-avatar" src="assets/img/avatar3.jpg?1404026799" alt="" />
                <strong>Alicia Adell</strong><br/>
                <small>Reviewing last changes...</small>
              </a>
            </li>
            <li class="dropdown-header">Options</li>
            <li><a href="">View all messages <span class="pull-right"><i class="fa fa-arrow-right"></i></span></a></li>
            <li><a href="">Mark as read <span class="pull-right"><i class="fa fa-arrow-right"></i></span></a></li>
          </ul>--><!--end .dropdown-menu -->
        </li><!--end .dropdown -->
      </ul><!--end .header-nav-options -->
      <div class="headerbar-right-lang">
        <app-language-dropdown></app-language-dropdown>
      
      <ul class="header-nav header-nav-profile">
        <li class="dropdown">
          <a href="javascript:void(0);" class="dropdown-toggle ink-reaction" data-toggle="dropdown">
            <img src="{{getSchoolImage}}" alt="" />
            <span class="profile-info">
              {{getSchoolName}}
              <small>{{getSchoolLocality}}, {{getSchoolState}}</small>
            </span>
          </a>
          <ul class="dropdown-menu animation-dock">
            <li class="dropdown-header">{{ 'header.signedInAs' | translate }} <b>{{loginMode == 'WEB_ADMIN' ? getSchoolName : staffName}}</b></li>
            <li *ngIf="loginMode == 'WEB_ADMIN'  && permissions.SETTINGS_MANAGEMENT == 'ENABLED'"><a
              style="cursor: pointer" [routerLink]="['/settings']">{{ 'header.profile' | translate }}</a></li>
              <!-- <li><a href="">My blog <span class="badge style-danger pull-right">16</span></a></li> -->
              <li class="hide"><a style="cursor: pointer" [routerLink]="['/broadcast']">{{ 'header.viewNotifications' | translate }}</a></li>
              <li class="divider"></li>
              <!-- <li><a href=""><i class="fa fa-fw fa-lock"></i> Lock</a></li> -->
              <!-- <li><a href="index.php"><i class="fa fa-fw fa-lock"></i> Lock</a></li> -->
              <li><a (click)="logout()" style="cursor: pointer"><i class="fa fa-fw fa-power-off text-danger"></i>
                {{ 'header.logout' | translate }}</a></li>
              </ul><!--end .dropdown-menu -->
            </li><!--end .dropdown -->
          </ul><!--end .header-nav-profile -->
        </div>
      <ul class="header-nav header-nav-toggle hide">
        <li>
          <!--<a class="btn btn-icon-toggle btn-default" href="#offcanvas-search" data-toggle="offcanvas" data-backdrop="false">
            <i class="fa fa-ellipsis-v"></i>-->
          <a class="btn btn-icon-toggle btn-default">
            <i class="fa fa-ellipsis-v"></i>
          </a>
        </li>
      </ul><!--end .header-nav-toggle -->
    </div><!--end #header-navbar-collapse -->
  </div>
  <div class="modal fade" id="modalTc" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" id="modalTcInside" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 *ngIf="isTcGenerationConfirm" class="modal-title" id="exampleModalLabel">{{'tcGenerationUnderProcess' | translate}}</h5>
          <h5 *ngIf="!isTcGenerationConfirm" class="modal-title" id="exampleModalLabel">{{'messageForTc' | translate}}</h5>
        </div>
        <div *ngIf="tcGeneratedJob && isTcGenerationConfirm" >
          <div class="message-status-tc">
            {{'generatingMessage' | translate}}
          </div>
          <span class="created-job-id">{{'jobId' | translate}} : # {{tcJobId}}</span>
        </div>
        <div  *ngIf="!tcGeneratedJob && isTcGenerationConfirm" class="tc-loader">
          <div class="spinner"></div>
        </div>
     
        <div class="modal-footer" *ngIf="isTcGenerationConfirm">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">{{'close' | translate}}</button>
          <button (click)="openTC()" type="button"  class="btn btn-primary">{{'openTC' | translate}}</button>
        </div>

        <div class="modal-footer" *ngIf="!isTcGenerationConfirm">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">{{'no' | translate}}</button>
          <button (click)="generateTcSelectedStudent()" type="button"  class="btn btn-primary">{{'yes' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="idCard" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" id="modalIdInside" role="document">
      <div  class="id-card-selection">
        <div  class="heading-id-card-selection">
         <span *ngIf="!isIdCardGenerated">{{ 'header.pleaseSelectIdCardTemplate' | translate }}</span>
         <span *ngIf="isIdCardGenerated">{{ 'header.congratulations' | translate }} !!</span>
        </div>

          <div *ngIf="!isIdCardGenerated && !isFetchingIdCard" class="id-image">
            <div *ngFor="let id of idCardTemplates" (click)="selectIdCard(id.templateId)" class="id-card-image">
              <div class="selection-container">
                <div *ngIf="!id.isSelected" class="selection-icon">
                </div>
                <div *ngIf="id.isSelected" class="selected-id-card">
                  <i class="ri-check-line"></i>
                </div>
              </div>
              <img  [src]="id.defaultTemplateImageUrl" alt="">
            </div>
          </div>

          <app-new-loader *ngIf="isFetchingIdCard">

          </app-new-loader>

          <div *ngIf="isIdCardGenerated" class="success-image">
            <div class="success-container">
              <i class="ri-check-line"></i>
            </div>
            <div class="message-for-id">
              {{ 'header.yourIdCardGenerationHasBeenScheduledYouCanCheckByClickingOnTheViewIdsButton' | translate }}
            </div>
          </div>

          <div *ngIf="!isIdCardGenerated" class="button-for-id-card">
            <div class="cancel-id-card">
              <button (click)="closeIdCard()">{{ 'header.cancel' | translate }}</button>
            </div>
            <div class="generate-id-card">
              <button (click)="generateIdCard()">
                <span *ngIf="!isGeneratingId">{{ 'header.generate' | translate }}</span>
                <span *ngIf="isGeneratingId"><app-button-loader></app-button-loader></span>
              </button>
            </div>
          </div>

          <div  *ngIf="isIdCardGenerated" class="button-for-id-card">
            <div class="cancel-id-card">
              <button (click)="closeIdCard()">{{ 'header.cancel' | translate }}</button>
            </div>
            <div class="generate-id-card">
              <button (click)="navigateToIdCardPage()">{{ 'header.viewIds' | translate }}</button>
            </div>
          </div>


       <div >

       </div>
      </div>
    </div>
  </div>

   <div class="modal fade" id="idCardStaff" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" id="modalIdInside" role="document">
      <div  class="id-card-selection">
        <div  class="heading-id-card-selection">
         <span *ngIf="!isStaffIdCardGenerated">{{ 'header.pleaseSelectIdCardTemplate' | translate }}</span>
         <span *ngIf="isStaffIdCardGenerated">{{ 'header.congratulations' | translate }} !!</span>
        </div>

          <div *ngIf="!isStaffIdCardGenerated && !staffIsFetchingIdCard" class="id-image">
            <div *ngFor="let id of staffIdCardTemplates" (click)="selectedStaffIdCard(id.templateId)" class="id-card-image">
              <div class="selection-container">
                <div *ngIf="!id.isSelected" class="selection-icon">
                </div>
                <div *ngIf="id.isSelected" class="selected-id-card">
                  <i class="ri-check-line"></i>
                </div>
              </div>
              <img  [src]="id.defaultTemplateImageUrl" alt="">
            </div>
          </div>

          <app-new-loader *ngIf="staffIsFetchingIdCard">

          </app-new-loader>

          <div *ngIf="isStaffIdCardGenerated" class="success-image">
            <div class="success-container">
              <i class="ri-check-line"></i>
            </div>
            <div class="message-for-id">
              {{ 'header.yourIdCardGenerationHasBeenScheduledYouCanCheckByClickingOnTheViewIdsButton' | translate }}
            </div>
          </div>

          <div *ngIf="!isStaffIdCardGenerated" class="button-for-id-card">
            <div class="cancel-id-card">
              <button (click)="closeStaffIdCard()">{{ 'header.cancel' | translate }}</button>
            </div>
            <div class="generate-id-card">
              <button (click)="generateStaffIdCard()">
                <span *ngIf="!isStaffGeneratingId">{{ 'header.generate' | translate }}</span>
                <span *ngIf="isStaffGeneratingId"><app-button-loader></app-button-loader></span>
              </button>
            </div>
          </div>

          <div  *ngIf="isStaffIdCardGenerated" class="button-for-id-card">
            <div class="cancel-id-card">
              <button (click)="closeStaffIdCard()">{{ 'header.cancel' | translate }}</button>
            </div>
            <div class="generate-id-card">
              <button (click)="navigateToStaffIdCardPage()">{{ 'header.viewIds' | translate }}</button>
            </div>
          </div>


       <div >

       </div>
      </div>
    </div>
  </div>

  
</header>



<!-- END HEADER-->